import ApiService from '@/services/ApiService'

const REPOSITORY_URL = 'precipitacion'

const PrecipitacionRepository = {
  crearPrecipitacion(idFichaAgricola, fecha, cantidad) {
    let data = {
      idFichaAgricola,
      fecha,
      cantidad
    }
    return ApiService.post(`${REPOSITORY_URL}/crear_precipitacion`, data)
  },

  listaPrecipitacion(idFichaAgricola) {
    let data = {
      idFichaAgricola
    }
    return ApiService.get(`${REPOSITORY_URL}/lista_precipitacion`, data)
  },

  actualizarPrecipitacion(idPrecipitacion, fecha, cantidad) {
    let data = {
      idPrecipitacion,
      fecha,
      cantidad
    }
    return ApiService.post(`${REPOSITORY_URL}/actualizar_precipitacion`, data)
  },

  borrarPrecipitacion(idPrecipitacion) {
    let data = {
      idPrecipitacion
    }
    return ApiService.post(`${REPOSITORY_URL}/borrar_precipitacion`, data)
  },
}

export default PrecipitacionRepository
